
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import ErrorBoundary from "./components/ErrorBoundary";
import { setupGlobalErrorLogging } from './lib/logger';

// Initialize global error logging
setupGlobalErrorLogging();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
